import { ArticleItemBody } from '#components/Article/Items/ArticleItemBody';
import { ArticleItemImage } from '#components/Article/Items/ArticleItemImage';
import { ArticleItemTeaserText } from '#components/Article/Items/ArticleItemTeaserText';
import { ArticleItemTitleLink } from '#components/Article/Items/ArticleItemTitleLink';
import { PublicationDate } from '#components/Article/PublicationDate';
import { ImageModule } from '#components/Image/ImageModule';
import type { LinkTeaser } from '#domains/resolver/board-section-data';
import { IconSystem } from '#icons/IconSystem';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

import styles from './BoardSectionItemTeaser.module.scss';

type Props = {
	teaser: LinkTeaser;
	isLarge?: boolean;
	sizes: string;
};

export function BoardSectionItemTeaser({ teaser, isLarge, sizes }: Props) {
	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: teaser.link.href,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => (
				<article className={`${styles.wrapper} ${isLarge ? styles.isLargeWrapper : ''}`} onClick={() => trackEvent({})}>
					<ArticleItemImage
						image={<ImageModule image={teaser.media} enableZoomEffect={true} sizes={sizes} />}
						path={teaser.link.href}
						title={teaser.title}
					/>

					<div className={styles.content}>
						<header className={styles.header}>
							<section className={styles.meta}>
								<PublicationDate className="body6" publicationDate={teaser.publicationDate} />
								<IconSystem icon="external-link" variant="outline" title="Externer Link" className={styles.teaserIcon} />
							</section>

							<ArticleItemTitleLink
								className={styles.title}
								headingClassName="heading1"
								path={teaser.link.href}
								title={teaser.link.text || 'Zum weiterführenden Link'}
							>
								{teaser.title}
							</ArticleItemTitleLink>
						</header>

						<ArticleItemBody>
							<ArticleItemTeaserText>{teaser.teaserText}</ArticleItemTeaserText>
						</ArticleItemBody>
					</div>
				</article>
			)}
		</Tracktor>
	);
}
